<template>
  <div class="page-container">
    <v-container>
      <v-row>
        <v-col cols="12">
          <!-- Hero Section -->
          <div class="hero-section mb-6">
            <h1 class="text-h4 font-weight-bold mb-2">
              Seguros para Desarrolladores y Freelancers Tech
            </h1>
            <p class="text-subtitle-1 grey--text text--darken-1">
              Protege tu carrera, tu negocio y la confianza de tus clientes con los
              seguros adecuados.
            </p>
          </div>

          <v-divider class="my-6"></v-divider>

          <!-- Por qué es importante -->
          <v-card class="pa-4 mb-6" color="primary lighten-5">
            <h2 class="text-h6 font-weight-medium mb-2">
              ⚠️ ¿Por qué un desarrollador necesita seguro?
            </h2>
            <p class="mb-0">
              Si trabajas como freelance, consultor o tienes una startup tecnológica,
              estás expuesto a riesgos como:
            </p>
            <ul class="mt-2">
              <li>Demandas por errores en el código</li>
              <li>Filtraciones de datos de clientes</li>
              <li>Proyectos cancelados inesperadamente</li>
              <li>Problemas con propiedad intelectual</li>
            </ul>
          </v-card>

          <!-- Tabla de seguros -->
          <h2 class="text-h5 font-weight-medium mb-4">
            Top 5 seguros para profesionales tech en 2026
          </h2>
          <v-simple-table class="comparativa-table mb-6">
            <thead>
              <tr>
                <th>Compañía</th>
                <th>Tipo de seguro</th>
                <th>Ideal para</th>
                <th>Precio desde</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Hiscox</strong></td>
                <td>Responsabilidad civil profesional</td>
                <td>Freelancers, consultores</td>
                <td>$29/mes</td>
              </tr>
              <tr>
                <td><strong>Lemonade</strong></td>
                <td>Seguro de negocio tech</td>
                <td>Startups, pequeñas empresas</td>
                <td>$35/mes</td>
              </tr>
              <tr>
                <td><strong>Next Insurance</strong></td>
                <td>Seguro integral para tech</td>
                <td>Desarrolladores freelance</td>
                <td>$40/mes</td>
              </tr>
              <tr>
                <td><strong>Cysurance</strong></td>
                <td>Ciberseguro + responsabilidad</td>
                <td>Empresas con manejo de datos</td>
                <td>$50/mes</td>
              </tr>
              <tr>
                <td><strong>Chubb</strong></td>
                <td>Ciberseguro empresarial</td>
                <td>Empresas tecnológicas</td>
                <td>Cotización personalizada</td>
              </tr>
            </tbody>
          </v-simple-table>

          <!-- Ciberseguro destacado -->
          <v-alert type="warning" class="mb-6">
            <strong>🔒 Ciberseguro:</strong> Especialmente importante si manejas datos
            sensibles de clientes. Cubre ransomware, filtraciones y pérdidas por
            interrupción del negocio.
          </v-alert>

          <v-divider class="my-6"></v-divider>

          <h2 class="text-h5 font-weight-medium mb-3">
            📋 ¿Cómo elegir el seguro adecuado?
          </h2>
          <v-row>
            <v-col cols="12" md="4" v-for="(tip, index) in tips" :key="index">
              <v-card class="pa-3 text-center" elevation="1">
                <v-icon size="40" color="primary" class="mb-2">{{ tip.icon }}</v-icon>
                <h4 class="text-subtitle-1 font-weight-medium">{{ tip.title }}</h4>
                <p class="text-caption mb-0">{{ tip.description }}</p>
              </v-card>
            </v-col>
          </v-row>

          <p class="text-caption text-center mt-6 grey--text">
            *Los precios y coberturas son referenciales. Este artículo es informativo, no
            constituye asesoría financiera.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaginaSegurosTech",
  data() {
    return {
      tips: [
        {
          icon: "mdi-account-check",
          title: "Evalúa tu perfil",
          description:
            "Freelance, consultor o empresa. Cada perfil necesita coberturas distintas.",
        },
        {
          icon: "mdi-database",
          title: "Manejo de datos",
          description: "Si manejas datos sensibles, prioriza un ciberseguro.",
        },
        {
          icon: "mdi-cash-multiple",
          title: "Compara precios",
          description: "Revisa deducibles, límites de cobertura y exclusiones.",
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.page-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 80px 20px 40px;
}
.hero-section {
  text-align: center;
}
.comparativa-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  padding: 14px;
}
.comparativa-table td {
  padding: 12px;
  border-bottom: 1px solid #e8eef2;
}
</style>
